export const therapists_aws = {
  Auth: {
    mandatorySignIn: true,
    region: "us-west-2",
    userPoolId: "us-west-2_MC4gAZCLq",
    userPoolWebClientId: "7fdjt0v5k3prvis9m0e3ebq358", //App Clied Id
    //identityPoolId: "Not made, we have make it",
  },
};
